const baseUri =
  typeof window !== 'undefined' && window.location && window.location.origin
    ? window.location.origin
    : (process.env.REACT_APP_BASE_URI || '').replace(/\/+$/, '');

/** Base URL for HON portal auth (no trailing slash). If unset, portal redirects are disabled. */
const honAuthBase = (process.env.REACT_APP_HON_AUTH || '').trim().replace(/\/+$/, '');

function buildPortalLoginUrl(returnPath) {
  if (!honAuthBase) {
    return '';
  }
  const path = returnPath && returnPath.startsWith('/') ? returnPath : '/login';
  const returnTarget = `${baseUri}${path}`;
  return `${honAuthBase}/PortalLogin.aspx?ReturnUrl=${encodeURIComponent(returnTarget)}`;
}

export default {
  api: {
    shareOfAccountsBaseUri: process.env.REACT_APP_SHARE_ACCT_API_URL,
    hniAuthBaseUri: process.env.REACT_APP_HNI_AUTH_URL,
  },
  auth: {
    loginUrl: buildPortalLoginUrl('/login'),
    logoutUrl: honAuthBase ? `${honAuthBase}/PortalLogin.aspx?Logoff=1` : '',
  },
  portalUrl: honAuthBase,
  faqUrl: process.env.REACT_APP_HON_FAQ,
  debugMode: process.env.REACT_APP_DEBUG_MODE,
  multinavScript: process.env.REACT_APP_MULTINAV_SCRIPT,
};
